// window.location.reload is non-configurable in jsdom; this wrapper exists to make it mockable
export function reloadWindow(): void {
  window.location.reload();
}
